'use strict';

module.exports = {
    appointmentButtonPosition: function () {
        const wrapper = document.querySelector('.appointment-btns-wrapper');

        if (!wrapper || !wrapper.querySelector('.appointment-btn[data-showroom]')
            || wrapper.dataset.planelioPositionInitialized) return;

        wrapper.dataset.planelioPositionInitialized = 'true';

        const bottom = wrapper.getAttribute('bottom');
        if (bottom) document.documentElement.style.setProperty('--appointment-btns-bottom', bottom);

        const footerMenu = document.querySelector('.footerMenu');
        const footer = footerMenu && (footerMenu.closest('footer') || footerMenu);
        if (!footer) return;

        const updateFooterOverlap = function () {
            wrapper.classList.toggle('is-footer-overlap',
                wrapper.getBoundingClientRect().bottom > footer.getBoundingClientRect().top);
        };

        window.addEventListener('scroll', updateFooterOverlap);
        window.addEventListener('resize', updateFooterOverlap);
        updateFooterOverlap();
    }
};
